import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleInput } from '../../Res/BaseInput';
import { Space, SearchButton, CancelButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { getval2Token, getUserInfoCompanyId, setVal2Token } from '../../../Login/Auth';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { ReqCustomerContractList } from '../../../../item/ItemCustomerContract';
import { api_getCustomerContractList } from '../../../../api/apiCustomerContract';
import moment from 'moment';
import { getItemsInfo, uuid } from '../../../../item/ItemTools';
import { WageType_Arr } from '../../../../item/ItemCustomerPosition';


export function ReserveSOPStep1({ id, setIsLoading, action }) {
  const [tokenId, setTokenId] = useState("")
  const [resumeId, setResumeId] = useState("")
  const [companyId] = useState(getUserInfoCompanyId())

  const [companyName, setCompanyName] = useState("")

  const [customerContractList, setCustomerContractList] = useState([])

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("recruitmentContractorStatus", id)
      // console.log(obj)
      setResumeId(obj.resumeId)
      setTokenId(id)
    }
  }, [id])
  // useEffect(() => {
  //   if (id !== undefined && id !== tokenId) {
  //     var rId = getval2Token("resumeId", id)
  //     setResumeId(rId)
  //     setTokenId(id)
  //   }
  // }, [id])

  function toSearch() {
    if (companyName === "")
      return
    var mReqCustomerContractList = new ReqCustomerContractList({ companyId, start: 0, limit: 1000 })
    mReqCustomerContractList.companyName = companyName
    mReqCustomerContractList.contractStatus = '1'
    getCustomerContractList(mReqCustomerContractList)
  }

  function getCustomerContractList(mReqCustomerContractList) {
    if (setIsLoading !== undefined)
      setIsLoading(true)
    //console.log("getCustomerContractList")
    //console.log(mReqCustomerContractList)
    api_getCustomerContractList({
      mReqCustomerContractList,
      success: (obj) => {
        console.log(obj)
        setCustomerContractList(obj.list)
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function toCancel() {
    setCompanyName("")
  }

  var title = "預定作業Step 1：請先挑選職缺"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleInput val={companyName} action={setCompanyName} placeholder={"請輸入廠商名稱，進行搜尋"} size={6} />
          <div className="col-md-3">
            <SearchButton action={toSearch} />
            <CancelButton name={"清除"} action={toCancel} />
          </div>
        </div>
      </div>
      <Space />
      <div className="hr-line-dashed"></div>

      {customerContractList.map((item) => (
        <ReserveSOPCustomerContractBox key={item.customerContractId} item={item} action={action} />
      ))}
    </>

  return (
    <>
      <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
      <ManagementPrompt />
      <SystemPromptInput />
    </>
  )
}


function ReserveSOPCustomerContractBox({ item, action }) {
  const [mItem, setItem] = useState({})
  const [customerContractId, setCustomerContractId] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [signAt, setSignAt] = useState("")
  const [isPublic, setIsPublic] = useState("")
  const [status, setStatus] = useState("")
  const [positions, setPositions] = useState([])


  useEffect(() => {
    if (item !== undefined && item !== mItem) {
      //console.log(item)
      setItem(item)
      setCustomerContractId(item.customerContractId)
      setCompanyName(item.companyName)
      setSignAt(moment(item.signAt).format('YYYY-MM'))
      setIsPublic(item.isPublic === 1 ? "是" : "否")
      setPositions(JSON.parse(item.positions))

      if (item.isDisable === 1) {
        setStatus(<span className="text-danger">停用</span>)
      } else if (item.days < 0) {
        setStatus(<span className="text-danger">過期</span>)
      } else {
        setStatus(<span className="text-info">有效</span>)
      }

    }
  }, [item])

  function toContractorResumeEdit(customerPositionId) {
    var tokenId = uuid(128, 64)
    console.log(customerPositionId)
    setVal2Token("customerContractId", customerContractId, tokenId)
    setVal2Token("customerPositionId", customerPositionId, tokenId)
    window.open("/CustomerPositionDetail/" + tokenId, "_blank");
  }
  function toAction(item) {
    action(2, customerContractId, item.customerPositionId)
  }

  return (
    positions.map((item, index) => (
      <div className="row m-b-sm" key={item.customerPositionId}>
        <div className="col-md-12">
          <div className="col-md-6">
            <a href="#A" onClick={e => toContractorResumeEdit(item.customerPositionId)}>{moment(signAt).format('YYYY-MM-DD')} {companyName} -
              {item.job}/{item.shift}/{getItemsInfo({ items: WageType_Arr, val: item.wageType })}
            </a>

          </div>
          <div className="col-md-3">
            <SearchButton action={toAction} item={item} name="預定" icon="" />
            {/* <button className="btn btn-success btn-facebook btn-outline" type="button" onClick={e=>action(2, customerContractId, item.customerPositionId)}>預定</button> */}
          </div>

        </div>
      </div>
    ))
  )
}
